(() => {
  const initProductV20 = (root) => {
    if (!root || root.dataset.kt20Ready === 'true') return;
    root.dataset.kt20Ready = 'true';

    const mainImage = root.querySelector('[data-kt20-main-image]');
    const zoom = root.querySelector('[data-kt20-zoom]');
    const zoomImage = root.querySelector('[data-kt20-zoom-image]');
    const openZoom = root.querySelector('[data-kt20-zoom-open]');
    const closeZoom = root.querySelector('[data-kt20-zoom-close]');

    const open = () => {
      if (!zoom || !zoomImage || !mainImage) return;
      zoomImage.src = mainImage.currentSrc || mainImage.src;
      zoom.classList.add('is-open');
      zoom.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      if (!zoom) return;
      zoom.classList.remove('is-open');
      zoom.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    openZoom?.addEventListener('click', open);
    closeZoom?.addEventListener('click', close);
    zoom?.addEventListener('click', (e) => { if (e.target === zoom || e.target === zoomImage) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && zoom?.classList.contains('is-open')) close(); });

    const mobileBar = root.querySelector('[data-kt20-mobile-buy]');
    const mobileAdd = root.querySelector('[data-kt20-mobile-add]');
    const mobilePrice = root.querySelector('[data-kt20-mobile-price]');
    const form = root.querySelector('[data-kt6-product-form]');
    const mainAdd = root.querySelector('[data-kt6-add]');
    const price = root.querySelector('[data-kt6-price]');

    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
    if (price && mobilePrice) {
      const syncPrice = () => { mobilePrice.textContent = price.textContent; };
      syncPrice();
      new MutationObserver(syncPrice).observe(price, { childList: true, characterData: true, subtree: true });
    }
    if (mainAdd && mobileAdd) {
      const syncAvailability = () => { mobileAdd.disabled = mainAdd.disabled; };
      syncAvailability();
      new MutationObserver(syncAvailability).observe(mainAdd, { attributes: true, attributeFilter: ['disabled'] });
    }

    if (mobileBar) {
      const hero = root.querySelector('.kt20-product-hero');
      const updateBar = () => {
        if (window.innerWidth > 640 || !hero) { mobileBar.classList.remove('is-visible'); return; }
        const rect = hero.getBoundingClientRect();
        mobileBar.classList.toggle('is-visible', rect.top < -220 && rect.bottom > 120);
      };
      window.addEventListener('scroll', updateBar, { passive: true });
      window.addEventListener('resize', updateBar, { passive: true });
      updateBar();
    }

    root.querySelectorAll('[data-kt6-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const fieldset = button.closest('[data-kt6-option]');
        const current = fieldset?.querySelector('legend small');
        if (current) current.textContent = button.dataset.value || button.textContent.trim();
      });
    });
  };

  const init = () => document.querySelectorAll('[data-kt20-product]').forEach(initProductV20);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
